module.exports = __webpack_public_path__ + "static/img/iconfont.edc15c6a.svg";